import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MODULES } from "@/data/course";
import { QUIZZES } from "@/data/quizzes";
import { GraduationCap, CheckCircle2, Circle } from "lucide-react";

export default function Quizzes() {
  const { progress } = useAuth();
  const scores = progress?.quiz_scores || {};

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight">Quizzes & XP</h1>
        <p className="text-slate-400 mt-1">Test your knowledge after each module. Earn 20 XP per correct answer.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {MODULES.map((m) => {
          const q = QUIZZES[m.id] || [];
          const score = scores[String(m.id)] || scores[m.id];
          const done = !!score;
          return (
            <Link key={m.id} to={`/quizzes/${m.id}`} data-testid={`quiz-card-${m.id}`}
              className="bg-[#0F172A] border border-slate-800 rounded-2xl p-5 hover:border-blue-500/50 transition-all">
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 rounded-lg bg-blue-500/15 border border-blue-500/20 grid place-items-center">
                  <GraduationCap className="w-5 h-5 text-blue-300" />
                </div>
                {done ? <CheckCircle2 className="w-5 h-5 text-emerald-400" /> : <Circle className="w-5 h-5 text-slate-600" />}
              </div>
              <div className="text-xs font-mono text-slate-500">Module {m.id}</div>
              <h3 className="font-display font-semibold leading-snug mt-0.5">{m.title}</h3>
              <div className="flex items-center justify-between mt-3 text-xs">
                <span className="text-slate-500 font-mono">{q.length} questions</span>
                {done && <span className="font-mono font-semibold text-emerald-400">{score.correct}/{score.total}</span>}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
